export default __webpack_public_path__ + "static/media/cake-3.b06f138e.jpg";